import { useCallback, useEffect, useState } from 'react';

const DEFAULT_REFETCH_TIME_MS = 1000 * 60 * 55; // 55 mins
const DEFAULT_WARNING_TIME_BEFORE_REFETCH_MS = 1000 * 60 * 5; // 5 mins

const useTimedRefetch = ({
  data,
  refetch,
  refetchTimeMs = DEFAULT_REFETCH_TIME_MS,
  remove,
  warningTimeBeforeRefetchMs = DEFAULT_WARNING_TIME_BEFORE_REFETCH_MS,
}: {
  data: unknown;
  refetch: () => unknown;
  refetchTimeMs?: number;
  remove: () => unknown;
  warningTimeBeforeRefetchMs?: number;
}) => {
  const [refetchSoon, setRefetchSoon] = useState(false);

  const removeAndRefetch = useCallback(() => {
    setRefetchSoon(false);
    // removing this key from cache causes loading state to be shown correctly
    remove();
    refetch();
  }, [setRefetchSoon, remove, refetch]);

  useEffect(() => {
    const refetchTimeout = setTimeout(() => {
      removeAndRefetch();
    }, refetchTimeMs);
    const warningTimeout = setTimeout(
      () => {
        setRefetchSoon(true);
      },
      Math.max(refetchTimeMs - warningTimeBeforeRefetchMs, 0),
    );
    return () => {
      clearTimeout(refetchTimeout);
      clearTimeout(warningTimeout);
    };
  }, [data, refetchTimeMs, removeAndRefetch, setRefetchSoon, warningTimeBeforeRefetchMs]);

  return { refetchSoon, removeAndRefetch };
};

export default useTimedRefetch;
